import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function Hero() {
  return <Section className="py-20 md:py-32" background="offwhite" data-id="element-70">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-71">
        <div data-id="element-72">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-73">
            Delivering Hope, One Supply at a Time
          </h1>
          <p className="text-lg md:text-xl font-inter text-neutral-charcoal mb-8" data-id="element-74">
            We redirect unused, unexpired medical supplies from U.S. hospitals
            to monastery clinics serving underserved Coptic communities in
            Egypt.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-75">
            <Button href="/donate" size="lg" data-id="element-76">
              Donate Now
            </Button>
            <Button href="/how-it-works" variant="secondary" size="lg" data-id="element-77">
              How It Works
            </Button>
          </div>
        </div>
        <div className="relative" data-id="element-78">
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-79">
            <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Medical supplies being prepared for shipping" className="w-full h-full object-cover" data-id="element-80" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-primary-gold p-4 rounded-lg shadow-lg" data-id="element-81">
            <p className="font-playfair font-bold text-white text-xl" data-id="element-82">
              100+ Pallets Shipped
            </p>
          </div>
        </div>
      </div>
    </Section>;
}